export default __webpack_public_path__ + "static/media/stair_2.1690190b.png";